import { call, put, takeEvery } from "redux-saga/effects";
import {
  getWorkFlowError,
  getWorkFlowSuccess,
  startWorkFlowError,
  startWorkFlowSuccess,
} from "./actions";
import { GET_WORK_FLOW, START_WORK_FLOW } from "./actionTypes";
import {
  getWorkFlowOneApi,
  postStartWorkFlow,
} from "../../resources/helper/wokFlows";

function* getWorkFlow({ payload: { wf } }) {
  try {
    const response = yield call(getWorkFlowOneApi, wf.id);
    yield put(getWorkFlowSuccess(response));
  } catch (error) {
    yield put(getWorkFlowError(error));
  }
}

function* startWorkFlow({ payload: { swf } }) {
  try {
    const response = yield call(postStartWorkFlow, swf.id);
    yield put(startWorkFlowSuccess(response));
  } catch (error) {
    yield put(startWorkFlowError(error));
  }
}

function* WorkFlowSaga() {
  yield takeEvery(GET_WORK_FLOW, getWorkFlow);
  yield takeEvery(START_WORK_FLOW, startWorkFlow);
}

export default WorkFlowSaga;
